
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { getToken } from '@/utils/auth'

class Upload {
  /**
   *
   * @param file 文件
   * @param action 请求地址
   * @param piece 切片大小
   * @param limit 并发限制
   * @param onProgress 进度事件
   * @param onSuccess 上传成功的回调
   * @param onFail 上传失败的回调
   */
  constructor({ file, action, onProgress, piece = 1024 * 1024 * 1, onSuccess, onFail, limit }) {
    this.file = file
    this.action = action
    this.piece = piece
    this.onProgress = onProgress
    this.onSuccess = onSuccess
    this.onFail = onFail
    this.limit = 2
    // 内部属性
    // 上传状态
    this.status = '' // ready success uploading fail destroy
    // 生成UUID
    this.uid = uuidv4()
    // 初始化
    this.init()
  }
  // 初始化
  init() {
    this.sourceList = [] // axios 取消列表
    this.chunks = [] // 分割的数组列表
    this.progressPercent = 0 // 进度
    this.status = 'ready'
    this.slice().then(d => { // 切片完成之后自动上传
      this.status = 'uploading'
      this.uploadChunks()
    })
  }
  // 切片
  slice() {
    const piece = this.piece
    return new Promise(resolve => {
      const totalSize = this.file.size // 文件总大小
      let start = 0 // 每次上传的开始字节
      let end = start + piece // 每次上传的结尾字节
      const chunks = []
      while (start < totalSize) {
        const blob = this.file.slice(start, end, this.file.type)
        chunks.push({
          blob,
          status: 'ready'
        })
        start = end
        end = start + piece
      }
      this.chunks = chunks
      resolve(chunks)
    })
  }
  // 上传 chunks
  uploadChunks(res) {
    if (this.status === 'fail') return false
    const chunks = this.chunks
    // 更改判断方式
    if (this.chunks.filter(item => item.status === 'uploading').length >= this.limit) return false

    const list = this.chunks.map((item, index) => index + 1)
    const uploadList = list.filter((item, index) => {
      return chunks[index].status === 'ready'
    })
    // 判断是不是有上传失败的
    const failList = chunks.filter(item => {
      return item.status === 'fail'
    })
    // 有错误直接抛出
    if (failList.length) {
      this.onFail && this.onFail()
      this.status = 'fail'
      return false
    }
    // 判断上传状态
    const successList = chunks.filter(item => {
      return item.status === 'success'
    })
    if (successList.length === this.chunks.length) {
      this.onProgress && this.onProgress(100)
      if (res) {
        // 返回上传成功之后的文件
        if (res.fileFullPath) {
          this.onSuccess({ ...res })
        }
      }
    }
    // 如果列表还有数据 就执行上传
    if (uploadList.length > 0) {
      const itemIndex = uploadList[0]
      this.upload(chunks[itemIndex - 1], itemIndex, chunks.length)
      this.uploadChunks()
    }
  }
  // 上传模块
  upload(chunk, chunkNumber, totalChunks) {
    const { blob: file } = chunk
    chunk.status = 'uploading'
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()
    this.sourceList.push(source)
    const form = new FormData()
    form.append('chunkNumber', chunkNumber)
    form.append('totalChunks', totalChunks)
    form.append('filename', this.file.name)
    form.append('directory', this.uid)
    form.append('relativePath', this.file.name)
    form.append('chunkSize', this.piece)
    form.append('currentChunkSize', file.size)
    form.append('totalSize', this.file.size)
    form.append('identifier', this.file.size + '-' + this.file.name)
    form.append('file', file, this.file.name)
    const token = getToken()
    // 上传表单
    axios({
      url: this.action,
      method: 'post',
      data: form,
      cancelToken: source.token,
      headers: {
        Authorization: token
      },
      onUploadProgress: progressEvent => {
        chunk.uploadSize = progressEvent.loaded
        this.showProgress()
      }
    }).then(d => {
      if (d.status === 200 && d.data.code === 3001) {
        chunk.status = 'success'
        this.uploadChunks(d.data.data)
      } else {
        return Promise.reject(new Error('上传失败'))
      }
      // 处理上传
    }).catch(e => {
      chunk.uploadSize = 0
      this.showProgress()
      chunk.status = 'fail'
      this.uploadChunks()
    })
  }
  // 取消上传
  remove() {
    this.status = 'fail'
    this.sourceList.forEach(item => {
      item.cancel('用户取消!')
    })
  }
  // 重新上传
  reload() {
    this.status = 'uploading'
    this.chunks.forEach(item => {
      if (item.status !== 'success') {
        item.status = 'ready'
      }
    })

    this.action = '/api/merchant/pfile/g/system/upload/resource/v2'

    this.uploadChunks()
  }
  // 进度回显
  showProgress() {
    let loaded = 0
    this.chunks.forEach(item => {
      loaded += item.uploadSize ? item.uploadSize : 0
    })
    if (loaded / this.file.size > 1) {
      this.progressPercent = 100
    }
    this.progressPercent = (loaded / this.file.size * 100).toFixed(2)
    this.onProgress && this.onProgress(this.progressPercent)
  }
}

export default Upload
